module.exports={close:"Sluiten",error:"Fout",info:"Informatie",success:"Geslaagd",warning:"Waarschuwing"};